import { EditorState } from 'draft-js';

const preventBlockDeletion = types => ({
  handleKeyCommand: (command, editorState, timestamp, editorMethods) => {
    if (command !== 'backspace') return 'not-handled';

    const selection = editorState.getSelection();
    if (
      !selection.isCollapsed() ||
      selection.getAnchorOffset() ||
      selection.getFocusOffset()
    ) {
      return 'not-handled';
    }
    const content = editorState.getCurrentContent();
    const startKey = selection.getStartKey();
    const block = content.getBlockForKey(startKey);
    const blockType = block.get('type');
    const lastBlock = content.getLastBlock();
    if (types.indexOf(blockType) > -1 || lastBlock.key === block.key) {
      editorMethods.setEditorState(
        EditorState.push(editorState, content, 'backspace-prevent'),
      );
      return 'handled';
    }
    return 'not-handled';
  },
});

export default preventBlockDeletion;
